// Định dạng + lưu bộ ID cho trang Tra cứu KC.
import type { LookupMode, MonthInfo, SegmentSource } from './api';

export const fmtNum = (n: number | null | undefined) => Math.round(Number(n) || 0).toLocaleString('vi-VN');
export const fmtPct = (d: number, digits = 1) =>
  `${(d * 100).toLocaleString('vi-VN', { maximumFractionDigits: digits })}%`;
export const fmtShort = (n: number) =>
  n >= 1e6
    ? `${(n / 1e6).toLocaleString('vi-VN', { maximumFractionDigits: 2 })}M`
    : n >= 1e3
    ? `${Math.round(n / 1e3).toLocaleString('vi-VN')}K`
    : String(Math.round(n));
export const fmtHours = (seconds: number) =>
  `${(seconds / 3600).toLocaleString('vi-VN', { maximumFractionDigits: seconds < 36000 ? 1 : 0 })} giờ`;
export const monthText = (key: string) => `T${Number(key.slice(5, 7))}/${key.slice(0, 4)}`;
export const dm = (iso: string) => `${iso.slice(8, 10)}/${iso.slice(5, 7)}`;
export const dmy = (iso: string) => `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}`;

/** "05/10, 12/10 → 14/10" (gộp ngày liền nhau). */
export function daysText(days: string[], max = 6): string {
  const sorted = [...days].sort();
  const runs: [string, string][] = [];
  for (const d of sorted) {
    const tail = runs[runs.length - 1];
    const next = tail ? new Date(Date.parse(`${tail[1]}T00:00:00Z`) + 86400000).toISOString().slice(0, 10) : '';
    if (tail && next === d) tail[1] = d;
    else runs.push([d, d]);
  }
  const shown = runs.slice(0, max).map(([a, b]) => (a === b ? dm(a) : `${dm(a)} → ${dm(b)}`));
  return runs.length > max ? `${shown.join(', ')}…` : shown.join(', ');
}

export const SOURCE_TEXT: Record<SegmentSource, string> = {
  MONTH_FILE: 'file tháng TikTok',
  DAILY: 'cộng file ngày',
  LEGACY: 'số cộng dồn cũ',
  MIXED: 'cộng dồn cũ + file ngày',
  NONE: 'chưa có dữ liệu',
};

/** Chữ nhỏ dưới nút tháng. */
export function monthHint(m: MonthInfo): { text: string; warn: boolean } {
  switch (m.status) {
    case 'MONTH_FILE':
      return { text: 'File tháng', warn: false };
    case 'RUNNING':
      return { text: `${m.dayFiles}/${m.dueDays} ngày`, warn: m.missingDays.length > 0 };
    case 'DAILY_COMPLETE':
      return { text: 'Đủ ngày', warn: false };
    case 'DAILY_INCOMPLETE':
      return { text: `Thiếu ${m.missingDays.length} ngày`, warn: true };
    case 'LEGACY':
      return { text: 'Cộng dồn cũ', warn: false };
    default:
      return { text: 'Chưa có', warn: true };
  }
}

// ---------------------------------------------------------------- bộ ID đã lưu (trong trình duyệt, đợt 1)

export interface SavedList {
  name: string;
  ids: string;
  emails: string[];
  mode: LookupMode;
  savedAt: string;
}

const KEY = 'kcLookup.savedLists.v1';

export function loadSaved(): SavedList[] {
  try {
    const v = JSON.parse(window.localStorage.getItem(KEY) || '[]');
    return Array.isArray(v) ? v.filter((x) => x && typeof x.name === 'string') : [];
  } catch {
    return [];
  }
}

export function storeSaved(list: SavedList[]) {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, 50)));
  } catch {
    /* trình duyệt chặn bộ nhớ: bỏ qua */
  }
}
